import { BusinessType, CompanyActivity, NationalIdType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEnum, requiredString } from '@/utils/zodUtils';
import { validateDocumentNumber } from '@/utils/zodValidation/validateDocumentNumber';

export const BusinessIdentificationFormSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      businessName: requiredString(t),
      nationalIdType: requiredEnum(NationalIdType, t),
      nationalIdNumber: requiredString(t),
      nationality: requiredString(t),
      companyActivity: requiredEnum(CompanyActivity, t),
      businessType: requiredEnum(BusinessType, t).nullable(),
    })
    .strict()
    .refine((data) => validateDocumentNumber(data.nationalIdNumber, data.nationalIdType), {
      message: t('INVALID_DOCUMENT_NUMBER'),
      path: ['nationalIdNumber'],
    });

export type BusinessIdentificationFormType = z.infer<ReturnType<typeof BusinessIdentificationFormSchema>>;
